import React, { FC, useEffect, useState, useContext } from 'react';
import { ValidationGroup } from 'devextreme-react/validation-group';
import { Container, Form, Row, Col, Button, ListGroup, ListGroupItem } from 'reactstrap';
import { FaTrash } from 'react-icons/fa';
import { AEAField, AEAFileModal, AEABatchGrid } from '@/components';
import { IFormProa } from '@interfaces/screens/form-proa.interface';
import { Utilities } from '@utils';
import { MainProaSubprojectFFRRPresenter } from '@presenters/screens/form-proa-ffrr.presenter';
import { IFileDto } from '@models/*';
import storeContext from '@/context/store-context';
import ErrorTable from '@/components/ui/aea-error-table/aea-error-table';
import styles from '../form-proa-subproject-ffrr.module.scss';
import { Toast } from "devextreme-react/toast";

export interface IBaseDataSubFFRR {
    step1: any;
    dataColumns: any;
    switchForm: boolean;
    files: Array<IFileDto>
    headerInfo: any;
    endDate: Date;
    alertEndDate: boolean;
    setEndDate(endDate: Date): void;
    handleSwitch(): void;
    setStep1(step1: any): void;
}
const { StoreContext } = storeContext;
const BaseLineSubProFFRR: FC<IBaseDataSubFFRR> = (props) => {

    const [baseLineProps, setBaseLineProps] = useState(null);
    const [beneficiariesProps, setBeneficiariesProps] = useState(null);
    const [readOnly, setReadOnly] = useState(false);
    const [files, setFile] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalExcel, setModalExcel] = useState<boolean>(false);
    const [gridDataExcel, setGridDataExcel] = useState(null);
    const [financers, setFinancers] = useState(props.headerInfo?.[2]?.value || null);
    const context = useContext(StoreContext);

    const [stepData, setStepData] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [Alerts, setAlerts] = useState(false);

    const [toastConfig, setToastConfig] = React.useState({
		isVisible: false,
		type: null,
		message: "",
	});
    
    const view: IFormProa = {
        state: {
            endDate: props.endDate,
            dataColumns: props.dataColumns,
            readOnly: readOnly,
            files,
            financers: financers,
            modalOpen,
            modalExcel,
            setFirstDataGridProps: setBaseLineProps,
            setSecondDataGridProps: setBeneficiariesProps,
            setReadOnly: setReadOnly,
            setEndDate: props.setEndDate,
            setFile,
            setModalOpen,
            setModalExcel,
            setGridDataExcel,
            handleSwitch: props.handleSwitch,
        },
        setAlerts: setAlerts,
        setStep1: props.setStep1,
        step1Data: props.step1,
        baseLineData: props.step1?.baseLineYears || null,
        beneficiariesData: props.step1?.beneficiaries || null,
        genericData: props.step1?.genericInfo || null
    }

    let validationGroup: ValidationGroup;
    const presenter = new MainProaSubprojectFFRRPresenter(view);

    useEffect(() => {        
        setBaseLineProps(null);
        setBeneficiariesProps(null);
        setRefresh(refresh => !refresh)
    }, [props.endDate])

    useEffect(() => {
        if(props.step1 === undefined) presenter.initStep1()
    }, [props.step1, props.switchForm]);

    useEffect(() => {
        if (props.headerInfo?.[2])
        setFinancers(props.headerInfo[2]?.value)
    }, [props.headerInfo, props.headerInfo?.[2]])

    useEffect(() => {
        if (files.length === 0 && props.files && props.files.length !== 0) setFile(props.files)
    }, [props.files])

    useEffect(() => {
        presenter.initializeStep1();
    }, [props.step1, presenter.currentBudgetStartDate, presenter.currentBudget, refresh]);

    useEffect(() => {
        if(!Utilities.isNullEmptyObject(baseLineProps) && !Utilities.isNullEmptyObject(beneficiariesProps)) getStepData()
    }, [props.step1, baseLineProps, beneficiariesProps, modalExcel, gridDataExcel])

    const onHidingToast = () => {
        setToastConfig({
        ...toastConfig,
        isVisible: false,
      });
    };

    const handleChange = (option: any) => {
        let message = presenter.handleChangeValue(option)
        
        if(!!message){
          setToastConfig({
            isVisible: true,
            type: 'info',
            message
          })
        }
      }

    const getStepData = () => {
        setStepData(
            <>
                <Row className={styles.gridRow}>
                    <AEABatchGrid {...baseLineProps} handleChange={handleChange} checkContent currentData={props.step1 !== undefined} modalExcel={modalExcel} gridDataExcel={gridDataExcel} presenter={presenter} onCellPreRender={presenter.onCellPreRender} ></AEABatchGrid>
                </Row>
                {(!presenter.validBeneficiaries() && props.step1 !== undefined) &&
                    <div style={{width:"100%", textAlign:"center"}}>
                        <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{presenter.currentLabels.get("AlertReqBeneficiaries")}</h6>
                    </div>
                }
                <Row className={styles.gridRow}>
                    <AEABatchGrid {...beneficiariesProps} checkContent currentData={props.step1 !== undefined} modalExcel={modalExcel} gridDataExcel={gridDataExcel} presenter={presenter}></AEABatchGrid>
                </Row>
            </>
        )
    }

    const render = () => {  
        return (
            <Container fluid={true}>
                <Form>
                    {(!props.alertEndDate) &&
                        <div style={{width:"100%", textAlign:"center"}}>
                            <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{presenter.currentLabels.get("AlertEndDateWrong")}</h6>
                        </div>
                    }
                    <ValidationGroup ref={ref => validationGroup = ref}>
                        <Row xs={2} md={2}>
                            <Col><AEAField {...presenter.initDate}></AEAField></Col>
                            <Col><AEAField {...presenter.endDate}></AEAField></Col>
                        </Row>
                        {(baseLineProps?.gridProps?.id && !!stepData && props.step1 !== undefined) && 
                            <ErrorTable 
                                gridId={baseLineProps?.gridProps?.id} 
                                showAlerts={Alerts}
                                checkFunction={presenter.checkRequiredFields}
                            />
                        }
                        {(baseLineProps?.gridProps?.id && !!stepData && props.step1 !== undefined && !props.alertEndDate && !Alerts) && 
                            <ErrorTable 
                                paintColumn
                                gridId={baseLineProps?.gridProps?.id} 
                                showAlerts={!props.alertEndDate}
                                checkFunction={presenter.checkEndDate}
                            />
                        }
                        {(beneficiariesProps?.gridProps?.id && !!stepData && props.step1 !== undefined && !props.alertEndDate && !Alerts) && 
                            <ErrorTable 
                                gridId={beneficiariesProps?.gridProps?.id} 
                                showAlerts={!props.alertEndDate}
                                checkFunction={presenter.checkEndDate}
                            />
                        }
                        {!!stepData && stepData}
                    </ValidationGroup>
                </Form>
                <label>{presenter.currentLabels.get('proaDocumentoUsuario')}</label>
                <Row>
                    <Col xs="12" sm="6" md="6">
                        <ListGroup>
                            {
                                files.map((file: IFileDto) => {
                                    if (Utilities.isNullObject(file.filePreviewUrl)) {
                                        return <ListGroupItem key={file.fileName}>{file.fileName} <button className={styles.delete_button} onClick={() => presenter.deleteDocument(file.fileName)}><FaTrash></FaTrash></button></ListGroupItem>
                                    }
                                    else {
                                        return <ListGroupItem key={file.fileName}><a href={file.filePreviewUrl} target="_blank">{file.fileName}</a> <Button className={styles.delete_button} onClick={() => presenter.deleteDocument(file.fileName)}><FaTrash></FaTrash></Button></ListGroupItem>
                                    }
                                })
                            }
                        </ListGroup>
                    </Col>
                </Row>
                <br />
                <Row className={styles.gridRow}>  
                    {!readOnly ?    
                        <Button className={styles.saveButton} onClick={presenter.openCloseModal}>{presenter.currentLabels.get('proaAgregarDocumentos')}</Button>
                        : <div></div>
                    }              
                    {!readOnly ?
                        <Button className={styles.saveButton}
                            disabled={props.step1 === undefined}
                            onClick={(e) => {
                                e.preventDefault();
                                setTimeout(() => {
                                    if (validationGroup.instance.validate().isValid) {
                                        presenter.saveStep1();
                                    } else {
                                        Utilities.notifyError(presenter.currentLabels.get("Datos invalidos"));
                                    }
                                }, 500);
                            }}>{presenter.currentLabels.get('Guardar')}
                        </Button>
                        : <div></div>
                    }
                    <Button onClick={(e) => {
                        context.history.push('/proyecta/proa')
                    }}>{presenter.currentLabels.get('Cancelar')}
                    </Button>
                </Row>
                <AEAFileModal
                    openModal={modalOpen}
                    onCancel={presenter.openCloseModal}
                    onSendDocument={presenter.addFile}
                    cancelButton={presenter.currentLabels.get('Cancelar')}
                    documentsHeader={presenter.currentLabels.get('proaAgregarDocumentos')}
                    documentsInputFile={presenter.currentLabels.get('proaDocumento')}
                    documentsInputFileRequired={presenter.currentLabels.get('proaDocumento')}
                    documentsInputName={presenter.currentLabels.get('proaNombreDocumento')}
                    documentsInputNameRequired={presenter.currentLabels.get('proaNombreDocumento')}
                    saveButton={presenter.currentLabels.get('Guardar')}
                ></AEAFileModal>
                <Toast
                    visible={toastConfig.isVisible}
                    message={toastConfig.message}
                    type={toastConfig.type}
                    onHiding={onHidingToast}
                    displayTime={10000}
                />
            </Container>
        )
    }
     return render();
    // else return <p>Cargando...</p>
}
export default BaseLineSubProFFRR;

